import * as React from 'react';
import styled from 'styled-components';
import { KCFColor } from 'styles/themes/KCFColor';

const StyledBadge = styled.div<{ $backgroundColor: string; $textColor: string }>`
    display: inline-block;
    background: ${({ $backgroundColor }) => $backgroundColor};
    color: ${({ $textColor: textColor }) => textColor};
    border-radius: 3px;
    padding: 2px 4px;
    font-weight: bold;
    min-width: 2ch;
    text-align: center;
`;

export type BadgeProps = Readonly<{
    count: number | null | undefined;
    textColor?: string;
    backgroundColor?: string;
}> &
    React.HTMLAttributes<HTMLDivElement>;

export function Badge({
    count = 0,
    backgroundColor = KCFColor.black,
    textColor = KCFColor.white,
    ...rest
}: BadgeProps) {
    return (
        <StyledBadge $backgroundColor={backgroundColor} $textColor={textColor} {...rest}>
            {count}
        </StyledBadge>
    );
}
